import React from 'react'
import defaultMedication from '../../assets/img/default-medication.png'

function HeaderDetail(props) {
  const {product} = props

  return (
    <>
      {![undefined, null].includes(product) && (
        <div className="card-product-detail">
          <div className="d-flex">
            <img
              src={product.product_logo || defaultMedication}
              alt=""
              height="65"
              className=""
            />
            <div className="ml-3">
              <h4 className="title-primary--xxl m-0 w-100 mb-2">
                {product?.product_name}
              </h4>
              <p className="txt-paragraph mb-1">{product?.formula_name}</p>
              <p className="txt-paragraph mb-1">{product?.presentation}</p>
              <p className="txt-paragraph mb-1">{product?.laboratory_name}</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default HeaderDetail
